






























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";

@Component({
    directives: {
        ClickOutside
    }
})
export default class FloatingContact extends Vue {
    @Prop({ default: () => [] }) offices?: Office[];

    @Prop({ default: () => [] }) links?: any;

    @Prop({ default: "" }) address?: string;

    @Prop({ default: "" }) email?: string;

    @Prop({ default: "" }) phone?: string;

    params: any = { per_page: 99, page: 1 };

    open = false;

    loading = false;

    localOffices: Office[] = [];

    private getOffices() {
        this.loading = true;

        // @ts-ignore
        axios
            .get("/api/offices", { params: { ...this.params } })
            .then((response: any) => (this.localOffices = response.data.data))
            .finally(() => (this.loading = false));
    }

    @Watch("offices", { immediate: true })
    handleOfficesChanged(offices: any) {
        this.localOffices = offices;
    }

    @Watch("open")
    handleOpened(isOpen: boolean) {
        if (isOpen && this.localOffices.length === 0) {
            this.getOffices();
        }
    }
}
